import { groupBy, orderBy } from 'lodash'
import { filterObject } from '../../utils'
import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'

import Checkbox from '../checkbox'
import Textbox from '../textbox'
import Label from '../label'
import LabelWithLink from '../labelWithLink'
import Link from '../link'
import Image from '../image'
import Select from '../select'
import CountryCode from '../countryCode'
import Tariffe from '../tariffe'
import DropDownSearch from '../selectsearch'
import MultiSelect from '../multiselect'
import Radio from '../radio'
import File from '../file'
import Datepicker from '../datepicker'
import Clearfix from '../clearfix'
// import Button from '../button'
import TextArea from '../textArea'
import Iframe from '../iframe'
import AttivaButton from '../attivaButton'
import AlertModal from '../alertModal'
import MobileWithOTPButton from '../mobileWithOTPButton'
import { FetchPOSPlan } from '../../state/api'
import  PrivacyFabrick from '../privacyfabrick'
import { VALIDATION_PATTERNS,MultiSelectComponents } from './../../state/stateExtension'

import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

class Widgets extends Component {
  constructor(props) {
    super(props)

    this.state = {
      plan: ''
    }
  }

  componentDidMount() {
      const { component, dispatch, guid } = this.props
      let url = 'OnboardRequestDetails/FetchPOSPlan';
      let body = { GUID: guid };
    FetchPOSPlan(url, body).then(json => {
      const dbplan = json && json.payLoad && json.payLoad.Plan && json.payLoad.Plan.toUpperCase();
      const planMap = { FLEX: 'flex', FLEXCRS: 'flexCRS', FLATCRS: 'flatCRS',FLEXMINI:'flexmini' };
      const plan = planMap[dbplan] || 'flat';
      this.setState({ plan });
    })
  }

  makeStatusAsHidden(component) {
    if(component && component.status) {
      component.status.splice(0, component.status.length);
      component.status.push('hidden');
    }
  }

  renderComponents(widget, allComponents) {
    // When Cittadinanza != Italy in step 1, remove the radio buttons of PERMESSO_SOGGIORNO in step 2
    const permessoSoggiorno = allComponents['DOCUMENTO_2-PERMESSO_SOGGIORNO'];
    if(permessoSoggiorno && permessoSoggiorno.status && permessoSoggiorno.status.indexOf('hidden') < 0) {
      this.makeStatusAsHidden(allComponents['DOCUMENTO_2-BUSTA_PAGA']);
      this.makeStatusAsHidden(allComponents['DOCUMENTO_2-PASSAPORTO']);
      this.makeStatusAsHidden(allComponents['DOCUMENTO_2-TESSERA_SANITARIA']);
      this.makeStatusAsHidden(allComponents['DOCUMENTO_2-PATENTE']);
      this.makeStatusAsHidden(allComponents['DOCUMENTO_2-CARTA_IDENTITA']);
    }

    const widgetComponents = widget.components.map(id => allComponents[id])

    return orderBy(widgetComponents, 'position').map(c => {
      if (
        !!c &&
        c.type !== null &&
        !(!c.status || !(c.status.indexOf('hidden') < 0))
      ) {
        switch (c.type) {
          case 'text':
            return c.id==='CELLULARE-NUM_CELLULARE'?<MobileWithOTPButton key={c.name} widget={widget} component={c} />:<Textbox key={c.name} widget={widget} component={c} />
          case 'TextArea':
            return <TextArea key={c.name} widget={widget} component={c} />
          case 'label':
            return c.value ? (
              <Label key={c.name} widget={widget} component={c} />
            ) : (
               c.id==='S1-S1S4D7'?<Label key={c.name} widget={widget} component={c} />:''
            )
          /* case 'primary':
          case 'inverse':
          case 'primary-inverse':
          case 'success': {
            return <Button key={c.name} widget={widget} text={c.value} {...c} />
          } */
          case 'inverse':
          case 'sella':
          case 'active': {
            return <AttivaButton key={c.name} widget={widget} component={c} />
          }
          case 'labelWithLink':
            return c.value ? (
              <LabelWithLink key={c.name} widget={widget} component={c} plan={this.props.plan} />
            ) : (
              ''
            )

          case 'link':
            return c.value ? (
              <Link key={c.name} widget={widget} component={c} />
            ) : (
              ''
            )

          case 'image':
            return <Image key={c.name} widget={widget} component={c} />

          case 'checkbox':
            return <Checkbox key={c.name} widget={widget} component={c} />

          case 'selectbox':
          if(c.fieldId==='S1S6D2' || c.id==='SETTORE_ATTIVITA_AZIENDA-DETTAGLIO_ATTIVITA_ECONOMICA')
          {
            return <DropDownSearch key={c.name} widget={widget} component={c} />
           
          }
          else if(MultiSelectComponents.indexOf(c.id)>-1)
          {
            let componentValues=[]
            componentValues=!!c.value && c.value!==''?c.value:[]
            return <MultiSelect  key={c.name} widget={widget} component={c} setSelectedOptions={componentValues} />
          }
          else if (c.id === 'CELLULARE-PREF_CELLULARE' || c.id === 'S2-S2S7D10') {
            return <CountryCode key={c.name} widget={widget} component={c} />
          }
          else if (c.id === 'S16-S16S1D1') {
            return <Tariffe key={c.name} widget={widget} component={c} />
          }
          else
          {
            return <Select key={c.name} widget={widget} component={c} />
          }

          case 'DropDownSearch':
            return <DropDownSearch key={c.name} widget={widget} component={c} />

          case 'radio':
            if(c.id === 'DOCUMENTO_2-TESSERA_SANITARIA') {
              return (<React.Fragment>
                <Radio key={c.name} widget={widget} component={c} />
                <br />
              </React.Fragment>);
            } else
              return <Radio key={c.name} widget={widget} component={c} />

          case 'file':
            return (
              <File
                key={c.name}
                widget={widget}
                component={c}
                components={this.props.components}
              />
            )

          case 'date':
            return <Datepicker key={c.name} widget={widget} component={c} />
          case 'spacer':
            return <div key={c.name} />
          case 'iframe':
            return (
              <Iframe key={c.id} name={c.name} widget={widget} component={c} />
            )
          case 'alert':
            return (
              <AlertModal title={c.title} content={c.value} component={c} />
            )
          case 'privacyfabrick':
              return <PrivacyFabrick widget={widget} component={c}/>
        }
      }
    })
  }

  renderWidgets() {
    let { plan } = this.state;

    const groupedWidgets = groupBy(
      filterObject(
        this.props.widgets,
        w =>
          (w.status.indexOf('hidden') < 0 && w.status.indexOf('ignoreValidation')< 0) &&
          (Number(w.code) > 0 ||
            VALIDATION_PATTERNS.alphanumeric.test(w.code) ||
            this.props.renderNegatives)
      ),
      'group'
    )

    /**
     * The grouped widgets index
     * @type {Array}
     * @hack needed to place on top the signaler widget
     */
    const groupKeys = Object.keys(groupedWidgets)
    const wynIndex = groupKeys.indexOf('WHAT_YOU_NEED')
    if (wynIndex > -1) {
      groupKeys.splice(wynIndex, 1)
      groupKeys.splice(0, 0, 'WHAT_YOU_NEED')
    }
    const signalerIndex = groupKeys.indexOf('SIGNALER')
    if (signalerIndex > -1) {
      groupKeys.splice(signalerIndex, 1)
      groupKeys.splice(groupKeys.length - 1, 0, 'SIGNALER')
    }

    return groupKeys.map((group /*, index*/) => {
      // @hack I know that the second condition is awful but i couldn't do any better, YOLO
      if (
        group === 'undefined' ||
        (group === 'RIF_SPEDIZIONE_CARTA' &&
          !!this.props.widgets.RIF_SPEDIZIONE_CARTA &&
          !!this.props.widgets.JOLLY &&
          this.props.widgets.JOLLY.status.indexOf('hidden') < 0)
      )
        return
      return (
        <div key={group} {...css(this.props.styles['widget-group'],group === 'SZ0025' || group==='PRIVACY' && this.props.styles['widget-group__margin-min-bottom'])}>
          {
            group==="DATI_SENSIBILI" && groupedWidgets[group][0].groupTitle === 'Privacy' &&
            <h4
            key={`${group}-title`}
            {...css(this.props.styles['widget-group__maintitle'])}
          >
            Privacy del contratto acquirer Banca Sella
          </h4>
          }
          {(groupedWidgets[group][0].groupTitle !== 'CONVENZIONE' || (plan === 'flat' || plan === 'flatCRS')) &&
            <h4
              key={`${group}-title`}
              {...css(this.props.styles['widget-group__title'])}
            >
              {groupedWidgets[group][0].groupTitle === "PRIVACY CONTRATTO AXERVE PER NOLEGGIO POS" ? "PRIVACY CONTRATTO DI ACQUIRING BANCA SELLA" : groupedWidgets[group][0].groupTitle}
            </h4>
          }
          <div
            key={`${group}-inputs`}
            {...css(
              this.props.styles['widget-group__inputs'],
              groupedWidgets[group].filter(
                w => w.status.indexOf('error') > -1 && !w.quiet
              ).length > 0
                ? this.props.styles['widget-group__inputs--invalid']
                : null
            )}
          >
            {groupedWidgets[group].map(w =>
              this.renderComponents(w, this.props.components)
            )}
          </div>
          <Clearfix key={`${group}-clearfix`} />
          <small
            key={`${group}-errors`}
            {...css(this.props.styles['widget-group__error-msg'])}
          >
            {groupedWidgets[group].map(w => (!w.quiet ? w.errorMessage : ''))}
          </small>
        </div>
      )
    })
  }

  render() {
    return <div>{this.renderWidgets()}</div>
  }
}

Widgets.propTypes = {
  components: PropTypes.object.isRequired,
  widgets: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired
}

const mapStateToProps = (state /*, ownProps*/) => {
  const { components } = state
  return { components }
}

export default connect(mapStateToProps)(withStyles(Styles)(Widgets))



// WEBPACK FOOTER //
// ./components/widgets/index.js